import { useMemo } from 'react';
import { ActionCreatorsMapObject, bindActionCreators } from 'redux';

import { useReduxDispatch } from '../useReduxDispatch';

export function useBoundActions<M extends ActionCreatorsMapObject, N extends ActionCreatorsMapObject>(
  actionCreators: M,
): N;

export function useBoundActions<A, M extends ActionCreatorsMapObject<A>>(actionCreators: M): M;

export function useBoundActions<A, M extends ActionCreatorsMapObject<A>>(actionCreators: M): M {
  const dispatch = useReduxDispatch();

  return useMemo(() => bindActionCreators(actionCreators, dispatch), [actionCreators, dispatch]);
}
